export default "__VITE_ASSET__CPfGn5ES__"